import React, { Component } from "react";

import arrowTop from '../../images/backtotop.png'

import './BackToTop.css';

class BackToTop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_visible: false
    };
  }

  componentDidMount() {
    var scrollComponent = this;
    document.addEventListener("scroll", function(e) {
      scrollComponent.toggleVisibility();
    });
  }

  toggleVisibility() {
    if (window.pageYOffset > 300) {
      this.setState({
        is_visible: true
      });
    } else {
      this.setState({
        is_visible: false
      });
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  render() {
    const { is_visible } = this.state;
    return (
      <div>
        {is_visible && (
          <div className="scroll-to-top" onClick={() => this.scrollToTop()}>
            <img src={arrowTop} alt="Flèche qui permet de revenir en haut de la page" />
          </div>
        )}
      </div>
    );
  }
}


export default BackToTop